import { RateCategoryService } from './../../services/rateCategoryService';
import { Router } from '@angular/router';
import { ServicesService } from './../../../services/services/servicesService';
import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { NbWindowService, NbToastrService } from '@nebular/theme';
import { ServiceCommentService } from '../../services/servicescomment';
import { ServicesHistoryervice } from '../../../versions/services/serviceHistoryService';

@Component({
  selector: 'ngx-rates-comments',
  templateUrl: './rates-comments.component.html',
  styleUrls: ['./rates-comments.component.css'],
})
export class RatesCommentsComponent implements OnInit {
  @ViewChild('ratecontentTemplate', { static: false }) contentTemplate: TemplateRef<any>;
  @ViewChild('anotherratecontentTemplate', { static: false }) anotherCatcontentTemplate: TemplateRef<any>;

  @Input() servicesHistories;
  @Input() serviceId;
  serviceHistoryId: number;
  selectedWeight: number;
  commentId: number;
  windowRf: any;
  anotherwindowRf: any;
  selectedanotherCat: number;
  val: any;
  anotherLoading: boolean;
  selectedCommentId: number;
  selectedHisId: number;
  constructor(
    private window: NbWindowService,
    private service: ServiceCommentService,
    private toast: NbToastrService,
    private historyService: ServicesHistoryervice,
    private res: ServicesService,
    private route: Router,
    private categoryService: RateCategoryService
  ) {}

  categories: any;
  ngOnInit(): void {
    // this.servicesHistories.forEach(element => {
    //   this.categories.push({id: element.i})
    // });
  }

  add(hisId: number, value: any) {
    this.commentId = value.id;
    this.val = value;
    this.selectedHisId = hisId;
    this.windowRf = this.window.open(this.contentTemplate);
  }

  save() {
    this.val.context = this.selectedWeight;
    console.log(this.selectedHisId);

    this.service.put(this.commentId, { Id: this.commentId, Weight: this.selectedWeight }).subscribe((res) => {
      this.analysisi(this.selectedHisId);
      this.windowRf.close();
      // this.res.getById(this.serviceId).subscribe((resp) => {
      //   this.servicesHistories = resp.servicesHistories;
      // });
      // this.toast.show('تم تحديث اهمية التعليق', '', { status: 'success', duration: 3000 });
    });
  }
// split(text: string){
//   console.log(text);
  
//   const arr = text.split(':');
//   return arr[0];
// }
  analysisi(id) {
    this.historyService.analysis(id).subscribe((res) => {
      this.servicesHistories.forEach((element) => {
        if (element.id === id) {
          element.totalRateAnalysis = res;
        }
      });
      console.log(this.servicesHistories);
      
    });
  }
  improvement(id) {
    this.route.navigate([`admin/plan/${id}/history`]);
  }

  anotherCategory(commentId: number, hisId) {
    this.selectedCommentId = commentId;
    this.categoryService.getApi('rateservice/' + this.serviceId).subscribe((res) => {
      this.categories = res;
      this.anotherLoading = true;
      this.anotherwindowRf = this.window.open(this.anotherCatcontentTemplate);
    });
  }

  saveAnotherCat() {
    this.service
      .getApi(`MoveComment?commentId=${this.selectedCommentId}&categoryId=${this.selectedanotherCat}`)
      .subscribe((res) => {
        this.anotherwindowRf.close();
      });
  }
}
